import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3wqhrgidgj: FaireBrandEntity = {
  token: "b_3wqhrgidgj",
  type: "brand",
  name: "Wholesome Good",
  avatarUrl:
    "https://cdn.faire.com/fastly/b9f48277a49119424ff730ee5e0a5e2638c1d8be7ceed3922492525fd7966adb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/bc046507b0d20d587807d8e45750c411f0578ae26b592cd0b9e020edbc957b06.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b9f48277a49119424ff730ee5e0a5e2638c1d8be7ceed3922492525fd7966adb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bc046507b0d20d587807d8e45750c411f0578ae26b592cd0b9e020edbc957b06.png",
  location: "Northbrook, IL, USA",
  minimumOrderDollars: 69,
  rating: 4.5,
  reviewCount: 73,
  isTopShop: true,
  isInsider: true,
  description:
    "Wholesome Good is more than just a brand; it's a mission to bring nutritious and natural food options to people's tables. At Wholesome Good, the focus is on quality, not quantity, and every product sourced is made with the finest natural ingredients.\n\nWholesome Good's story began when the founders realized the lack of wholesome and unique food options in small town grocers. Thus, the mission was formed: to seek out and learn about niche products in the specialty foods industry, then share these experiences with their community.\n\nAt Wholesome Good, they make it simple to buy food. Their higher purpose is to give people access to a unique variety of delicious, all-natural, and organic foods and make it easy to order them. Wholesome Good partners with small specialty food manufacturers and helps them extend their reach to as many tables and families as possible.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:06.956Z",
    importedBy: "entity-db-cli",
  },
};
